module.exports = __webpack_public_path__ + "static/media/mainmb.0166faba.png";